<h1 mat-dialog-title>{{ title }}</h1>
<p>{{ description }}</p>
<div class="dialog-options">
  <app-text-button type="button" class="close-button" color="accent" (click)="reject()">
    {{ rejectButton }}
  </app-text-button>
  <app-text-button class="submit-button" (click)="accept()" cdkFocusInitial>
    {{ acceptButton }}
  </app-text-button>
</div>
